__turbopack_context__.v({
  "lg": "ifVBra_lg",
  "md": "ifVBra_md",
  "root": "ifVBra_root",
  "segment": "ifVBra_segment",
  "sm": "ifVBra_sm",
  "thumb": "ifVBra_thumb",
});
